import React from "react";
import AdgerdirPage from "@components/Pages/AdgerdirPage/AdgerdirPage";

export default function Software() {
    return <AdgerdirPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
